/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React from 'react';
import { MenuIdAppSwitcher } from '@jira/navigation-apps__constants/src/MenuIdAppSwitcher.tsx';
import { TopLevelErrorBoundary } from '@jira/navigation-apps__topnav-common/src/ui/error-boundary/index.tsx';
import { AppSwitcherTrigger } from './trigger/index.tsx';

function AppSwitcher(): React.JSX.Element {
	return (
		<TopLevelErrorBoundary id={MenuIdAppSwitcher}>
			<AppSwitcherTrigger />
		</TopLevelErrorBoundary>
	);
}

export default AppSwitcher;
